import * as actionTypes from './actions';
import { updateObject } from '../../hoc/update-object/update-object';

const initialState = {
  loaded: false,
  name: '',
  body: '',
  image: ''
}

const getContentSuccess = (state, action) => {
  return updateObject(state, {
    loaded: action.content.loaded,
    name: action.content.name,
    body: action.content.body,
    image: action.content.image
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CONTENT_AUTHOR_PAGE_SUCCESS: return getContentSuccess(state, action);
    default: return state;
  }
}

export default reducer;